var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('modal',{attrs:{"visible":_vm.loading,"id":"app-spinner","closable":false}},[_c('moon-loader',{attrs:{"size":"120px","color":"#fff"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }